import { useRef } from "react";

import { Dialog, IconButton } from "@mui/material";
import { Camera, CameraType } from "react-camera-pro";
import { CameraAlt, Close } from "@mui/icons-material";

type CameraDrawerProps = {
  open: boolean;
  onClose: () => void;
  onPhotoTaken: (arg:string) => void;
};

const CameraDrawer = ({ open, onClose, onPhotoTaken }: CameraDrawerProps) => {
  const camera = useRef<CameraType>(null);

  return (
    <Dialog open={open} fullScreen>
      <div style={{
        position: 'fixed',
        zIndex: 1,
        width: '100%',
        height: '100%'
      }}>
        <Camera
          ref={camera}
          aspectRatio="cover"
          facingMode="environment"
          errorMessages={{
            noCameraAccessible:
              "No camera device accessible. Please connect your camera or try a different browser.",
            permissionDenied:
              "Permission denied. Please refresh and give camera permission.",
            switchCamera:
              "It is not possible to switch camera to different one because there is only one video device accessible.",
            canvas: "Canvas is not supported.",
          }}
          videoReadyCallback={() => {
            console.log("Video feed ready.");
          }}
        />
        <IconButton
          style={{
            position: "absolute",
            top: "1rem",
            right: "1rem",
          }}
          onClick={() => onClose()}
        >
          <Close />
        </IconButton>
        <IconButton
          style={{
            position: "absolute",
            bottom: "1rem",
            right: "1rem",
            border: "1px solid",
            margin: "auto",
          }}
          onClick={() => {
            if (camera.current) {
                onPhotoTaken(camera.current.takePhoto("base64url") as string)
            }
            
          }}
        >
          <CameraAlt />
        </IconButton>
      </div>
    </Dialog>
  );
};

export default CameraDrawer;
